import { FC } from 'react';

export const Privacy: FC = () => {
	return <h1>Политика Конфиденациальности</h1>;
};
